var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCottionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    d: "M7.42029 24C5.25604 24 3.4628 23.2889 2.04058 21.8667C0.680193 20.3852 0 18.4296 0 16C0 10.5481 1.85507 6.28148 5.56522 3.2C7.17295 1.77778 9.02802 0.711112 11.1304 0L12.058 2.22222C10.7594 2.63704 9.46087 3.31852 8.16232 4.26666C5.44155 6.22222 3.8029 8.8 3.24638 12L4.45217 11.3778C5.44155 10.9037 6.43092 10.6667 7.42029 10.6667C9.27536 10.6667 10.8831 11.3481 12.2435 12.7111C13.6657 14.0148 14.3768 15.5556 14.3768 17.3333C14.3768 19.1111 13.6657 20.6815 12.2435 22.0444C10.8831 23.3481 9.27536 24 7.42029 24ZM25.0435 24C22.8792 24 21.086 23.2889 19.6638 21.8667C18.3034 20.3852 17.6232 18.4296 17.6232 16C17.6232 10.5481 19.4783 6.28148 23.1884 3.2C24.7343 1.77778 26.5894 0.711112 28.7536 0L29.6812 2.22222C28.3826 2.63704 27.0841 3.31852 25.7855 4.26666C23.0647 6.22222 21.4261 8.8 20.8696 12L22.0754 11.3778C23.0647 10.9037 24.0541 10.6667 25.0435 10.6667C26.8986 10.6667 28.5063 11.3481 29.8667 12.7111C31.2889 14.0148 32 15.5556 32 17.3333C32 19.1111 31.2889 20.6815 29.8667 22.0444C28.5063 23.3481 26.8986 24 25.0435 24Z",
    fill: "#295BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCottionMark);
export default __webpack_public_path__ + "static/media/cottionMark.769ffe173a4dd4aeb63d5f9d775a4abf.svg";
export { ForwardRef as ReactComponent };